module.exports = __webpack_public_path__ + "assets/images/intrack-login-background.png";